module.exports = __webpack_public_path__ + "static/media/ico_referencia_new.57cfad83.svg";